import { Button, Drawer, styled } from '@liscio/ui';

export const StyledButton = styled(Button)({
  paddingTop: 5,
  paddingBottom: 5,
  paddingLeft: 40,
  paddingRight: 40,
  borderRadius: 2,
});

export const StyledDrawer = styled(Drawer)({
  '& .MuiDrawer-paper': {
    backgroundColor: 'white',
    color: 'inherit',
    maxWidth: '40rem',
    width: '40vw',
  },
});
